var map = {
	"./banner 1.jpg": 992,
	"./banner 2.jpg": 1311,
	"./banner 3.jpg": 4930,
	"./banner 4.jpg": 8529,
	"./banner 5.jpg": 8580,
	"./banner 6.jpg": 1155,
	"./banner 7.jpg": 6390,
	"./banner 8.jpg": 5381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7443;